const serverDomain = "https://www.zylascope.com/appstar-v1.1r-backend/";
const siteKey = "6LdhJ-MrAAAAAFylAywOIcu9oezvyoLK2CEt5DWx";

export { serverDomain, siteKey };
